import { API_BASE_URL, FRONT_LOG_INGEST_ENABLED } from "../config/endpoints.js";
import { getAccessToken } from "../utils/tokenStorage.js";

const logLocal = (level, event, payload = {}) => {
  const entry = {
    timestamp: new Date().toISOString(),
    level,
    service: "techdash-front",
    event,
    ...payload,
  };

  const line = JSON.stringify(entry);
  if (level === "error") {
    console.error(line);
    return;
  }
  if (level === "warn") {
    console.warn(line);
    return;
  }
  console.log(line);
};

const shipFrontendLog = async (level, event, payload = {}) => {
  if (!FRONT_LOG_INGEST_ENABLED) {
    return;
  }

  const token = getAccessToken();
  if (!token) {
    return;
  }

  try {
    await fetch(`${API_BASE_URL}/api/observability/frontend-log`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        level,
        event,
        payload,
      }),
    });
  } catch {
    // keep frontend resilient; shipping failures should never block UI
  }
};

const logInfo = (event, payload = {}) => {
  logLocal("info", event, payload);
  void shipFrontendLog("info", event, payload);
};

const logWarn = (event, payload = {}) => {
  logLocal("warn", event, payload);
  void shipFrontendLog("warn", event, payload);
};

const logError = (event, payload = {}) => {
  logLocal("error", event, payload);
  void shipFrontendLog("error", event, payload);
};

export { logInfo, logWarn, logError };
